function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "Options");

var _ref3 = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.");

var _ref4 = /*#__PURE__*/React.createElement("g", {
  id: "Page-1",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd",
  opacity: 0.541317894
}, React.createElement("g", {
  id: "white-copy",
  transform: "translate(-926.000000, -297.000000)",
  fill: "#000000",
  fillRule: "nonzero"
}, React.createElement("g", {
  id: "Group-10",
  transform: "translate(73.000000, 297.000000)"
}, React.createElement("g", {
  id: "more",
  transform: "translate(856.000000, 10.500000) rotate(-90.000000) translate(-856.000000, -10.500000) translate(845.500000, 7.500000)"
}, React.createElement("path", {
  d: "M21,3 C21,4.65692041 19.6569204,6 18,6 C16.3430796,6 15,4.65692041 15,3 C15,1.34332806 16.3430796,0 18,0 C19.6569204,0 21,1.34332806 21,3 L21,3 Z",
  id: "Path"
}), React.createElement("path", {
  d: "M14,3 C14,4.65692041 12.6569204,6 11,6 C9.34332811,6 8,4.65692041 8,3 C8,1.34332806 9.34332811,0 11,0 C12.6569204,0 14,1.34332806 14,3 Z",
  id: "Path"
}), React.createElement("path", {
  d: "M6,3 C6,4.65692041 4.65692041,6 3,6 C1.34307959,6 1.13686838e-13,4.65692041 1.13686838e-13,3 C1.13686838e-13,1.34332806 1.34307959,0 3,0 C4.65692041,0 6,1.34332806 6,3 Z",
  id: "Path"
})))));

const SvgBigMore = (_ref) => {
  let svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    width: "6px",
    height: "21px",
    viewBox: "0 0 6 21",
    ref: svgRef
  }, props), _ref2, _ref3, _ref4);
};

const ForwardRef = React.forwardRef((props, ref) => React.createElement(SvgBigMore, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/big-more.285663f0.svg";
export { ForwardRef as ReactComponent };